import type { PostV1Scenarios200, PostV1Scenarios422, PostV1ScenariosMutationRequest, PostV1ScenariosMutationResponse } from '../models'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { scenarioInsertSchema } from './scenarioInsertSchema'
import { scenarioSchema } from './scenarioSchema'
import { z } from 'zod'

/**
 * @description The created scenario
 */
export const postV1Scenarios200Schema = z.lazy(() => scenarioSchema) as unknown as ToZod<PostV1Scenarios200>

export type PostV1Scenarios200Schema = PostV1Scenarios200

/**
 * @description The validation error(s)
 */
export const postV1Scenarios422Schema = z.object({
  success: z.boolean(),
  error: z.object({
    issues: z.array(
      z.object({
        code: z.string(),
        path: z.array(z.union([z.string(), z.number()])),
        message: z.string().optional(),
      }),
    ),
    name: z.string(),
  }),
}) as unknown as ToZod<PostV1Scenarios422>

export type PostV1Scenarios422Schema = PostV1Scenarios422

/**
 * @description The scenario to create
 */
export const postV1ScenariosMutationRequestSchema = z.lazy(() => scenarioInsertSchema) as unknown as ToZod<PostV1ScenariosMutationRequest>

export type PostV1ScenariosMutationRequestSchema = PostV1ScenariosMutationRequest

export const postV1ScenariosMutationResponseSchema = z.lazy(() => postV1Scenarios200Schema) as unknown as ToZod<PostV1ScenariosMutationResponse>

export type PostV1ScenariosMutationResponseSchema = PostV1ScenariosMutationResponse